import {Box, Button, Grid} from "@mui/material";
import React from "react";
import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";
import next_arrow from "./img/next_arrow.svg";


/**
 *
 * Displays the Previous and Next button navigation on the instruction pages before a facial scan.
 *
 * @param handleNext
 * @param handlePrevious [OPTIONAL] if not provided a previous button will not be shown
 * @param nextLabel [OPTIONAL] Overrides the next button label.
 *                   If not provided defaults to localized string pages.MaskSelectorTool.ScanInstructions.nextButton
 * @param nextDisabled [OPTIONAL] Is the next button disabled?  Defaults to false.
 *
 */
const BackNextNavigation = ( { handleNext,
                                 handlePrevious = undefined,
                                 nextLabel = undefined,
                                 nextDisabled = false,
                                 containerClassName = undefined,
} ) => {

    const { t } = useTranslation("pages.MaskSelectorTool.ScanInstructions");
    const nextButton = nextLabel === undefined  ? t("nextButton") : nextLabel;
    const backButton = t("backButton");

    const {classes} = MaskSelectorToolStyles();

    const concatenatedClassNames = `${classes.dual_button_group} ${containerClassName}`

    const navButtons = (postfix) => {
        return (
            <>
                {handlePrevious && (
                    <Button disableRipple variant="text" onClick={handlePrevious}
                            sx={{height: '40px'}}
                            data-testid={'nav-prev-button' + postfix}>
                        {backButton}
                    </Button>
                )}
                <Button
                    sx={{height: '40px', paddingRight: '16px'}}
                    disableRipple
                    variant="contained"
                    color="secondary"
                    disabled={nextDisabled}
                    onClick={handleNext}
                    data-testid={'nav-next-button' + postfix}>
                    {nextButton}
                    <Box padding='3px'></Box>
                    <img alt="" src={next_arrow}/>
                </Button>
            </>
        )
    }

    return(
    <>
        {/* Only shown in desktop mode. */}
        <Box className={concatenatedClassNames}>
            <Grid container sx={{display: 'flex', justifyContent: 'space-between'}}>
                {navButtons('')}
            </Grid>
        </Box>

        {/* Only shown in mobile mode. */}
        <Box className={classes.dual_button_group_mobile} >
            <Box className={classes.dual_button_group_mobile_inner}>
                {navButtons('-mobile')}
            </Box>
        </Box>
    </>
    )
}

export default BackNextNavigation